import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckSquare } from "@fortawesome/free-solid-svg-icons";
import { faGlobe } from "@fortawesome/free-solid-svg-icons";
import { faLaptop } from "@fortawesome/free-solid-svg-icons";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import { Card, Col, Container, Row } from "react-bootstrap";
import summaryCss from "./Summary.module.css";
import CountUp from "react-countup";
import VisibilitySensor from "react-visibility-sensor";

export default function Summary() {
  return (
    <>
      <Container
        fluid={true}
        className={`${summaryCss.summaryContainer} my-5 `}
      >
        <div className={`${summaryCss.summaryOverlay}`}></div>

        <Row className="g-0">
          <Col lg={8} md={6} sm={12}>
            <Row className="g-0">
              <Col
                className={`${summaryCss.sumaryContent} text-white text-center`}
              >
                <FontAwesomeIcon
                  icon={faGlobe}
                  className={`${summaryCss.Icons}`}
                />
                <h1 className={`${summaryCss.counterNumber}`}>
                  <CountUp start={0} end={3000}>
                    {({ countUpRef, start }) => (
                      <div>
                        <VisibilitySensor onChange={start}>
                          <span ref={countUpRef} />
                        </VisibilitySensor>
                      </div>
                    )}
                  </CountUp>
                </h1>
                <h4 className={`${summaryCss.counterTitle}`}>
                  Students Worldwide
                </h4>
                <div className={`${summaryCss.bottom}`}></div>
              </Col>
              <Col
                className={`${summaryCss.sumaryContent} text-white  text-center`}
              >
                <FontAwesomeIcon
                  icon={faLaptop}
                  className={`${summaryCss.Icons}`}
                />

                <h1 className={`${summaryCss.counterNumber}`}>
                  <CountUp start={0} end={220}>
                    {({ countUpRef, start }) => (
                      <div>
                        <VisibilitySensor onChange={start}>
                          <span ref={countUpRef} />
                        </VisibilitySensor>
                      </div>
                    )}
                  </CountUp>
                </h1>
                <h4 className={`${summaryCss.counterTitle}`}>
                  Courses published
                </h4>
                <div className={`${summaryCss.bottom}`}></div>
              </Col>
              <Col
                className={`${summaryCss.sumaryContent} text-white  text-center`}
              >
                <FontAwesomeIcon
                  icon={faStar}
                  className={`${summaryCss.Icons}`}
                />

                <h1 className={`${summaryCss.counterNumber}`}>
                  <CountUp start={0} end={2000}>
                    {({ countUpRef, start }) => (
                      <div>
                        <VisibilitySensor onChange={start}>
                          <span ref={countUpRef} />
                        </VisibilitySensor>
                      </div>
                    )}
                  </CountUp>
                </h1>
                <h4 className={`${summaryCss.counterTitle}`}>
                  Students Reviews
                </h4>
                <div className={`${summaryCss.bottom}`}></div>
              </Col>
            </Row>
          </Col>
          <Col lg={4} md={6} sm={12} className={`${summaryCss.sumaryContent}`}>
            <Card style={{ margin: "0 auto" }}>
              <Card.Body>
                <Card.Title className="text-center">
                  What I Have Achieved?
                </Card.Title>
                <Card.Text className={`${summaryCss.cardDes} `}>
                  <p>
                    <FontAwesomeIcon icon={faCheckSquare} />
                    <span className="ms-1">Requirment Gathering</span>
                  </p>
                  <p>
                    <FontAwesomeIcon icon={faCheckSquare} />
                    <span className="ms-1">System Analysis</span>
                  </p>
                  <p>
                    <FontAwesomeIcon icon={faCheckSquare} />
                    <span className="ms-1">Coding</span>
                  </p>
                  <p>
                    <FontAwesomeIcon icon={faCheckSquare} />
                    <span className="ms-1">Implementation</span>
                  </p>
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}
